// extracted by mini-css-extract-plugin
export default {"window":"cameModal_window__0wrpU","form":"cameModal_form__9Aw72","closeX":"cameModal_closeX__Te-K8"};